window.EMBUpload = {

  async upload(blob, designId) {

    const filename =
      `${designId}.png`;

    const { error } =
      await window.embroiderySupabase.storage
        .from("embroidery-previews")
        .upload(
          filename,
          blob,
          {
            contentType: "image/png",
            upsert: true
          }
        );

    if (error) {

      console.error(
        "UPLOAD FAILED",
        error
      );

      throw error;

    }

    const { data } =
      window.embroiderySupabase.storage
        .from("embroidery-previews")
        .getPublicUrl(
          filename
        );

    return data.publicUrl;

  }

};